// Mock data for Urpe School of Liberty

export const mentors = [
  {
    id: 1,
    name: "Diego Urquijo",
    role: "Emprendedor & Presidente",
    company: "Urpe School of Liberty",
    bio: "Emprendedor, estratega y arquitecto de negocios. Ha creado y escalado más de seis empresas en EE. UU. y LATAM, ayudando a miles de emprendedores a construir sistemas que operan con IA y estructura empresarial. Filosofía: \"El conocimiento no te da libertad. Aplicarlo, sí.\"",
    image: "https://customer-assets.emergentagent.com/job_knowledge-hub-196/artifacts/2glef15e_E2A6568F-F295-4493-B035-AB6A203F30DC.JPEG"
  },
  {
    id: 2,
    name: "Sebastián Torres",
    role: "Co-emprendedor & CTO",
    company: "NexaAI Solutions",
    bio: "Ingeniero con 12 años de experiencia construyendo productos de IA. Ha liderado equipos técnicos en startups que escalaron a más de 10M usuarios.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400"
  },
  {
    id: 3,
    name: "María Fernández",
    role: "Emprendedora & CEO",
    company: "ScaleHub Ventures",
    bio: "Experta en operaciones y escalamiento. Ha construido tres empresas rentables en LATAM y asesora a fondos de inversión sobre estrategia de crecimiento.",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400"
  },
  {
    id: 4,
    name: "Carlos Mendoza",
    role: "VP de Growth",
    company: "Velocity Marketing Group",
    bio: "Especialista en marketing de performance y adquisición. Ha escalado presupuestos de +$5M en Meta, Google y TikTok con retornos sostenibles.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400"
  },
  {
    id: 5,
    name: "Andrea Ramírez",
    role: "Directora de Estrategia",
    company: "Quantum Consulting",
    bio: "Consultora estratégica con experiencia en Fortune 500. Ayuda a empresas a diseñar ventajas competitivas en mercados digitales.",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400"
  },
  {
    id: 6,
    name: "Roberto Silva",
    role: "Emprendedor",
    company: "AutoFlow Systems",
    bio: "Pionero en automatización empresarial. Ha implementado soluciones no-code que ahorraron +100,000 horas operativas en empresas globales.",
    image: "https://images.unsplash.com/photo-1556157382-97eda2d62296?w=400"
  },
  {
    id: 7,
    name: "Laura Vega",
    role: "Chief Revenue Officer",
    company: "Momentum Sales",
    bio: "Experta en ventas B2B y estrategias de monetización. Ha cerrado contratos por +$50M y entrenado equipos comerciales de alto rendimiento.",
    image: "https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=400"
  },
  {
    id: 8,
    name: "Javier Morales",
    role: "Co-emprendedor & CMO",
    company: "BrandForge Media",
    bio: "Estratega de marca y contenido. Ha construido audiencias de +1M seguidores y posicionado a emprendedores como líderes de opinión en sus industrias.",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400"
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "Aprendimos a dirigir con datos, no con suposiciones. Urpe transformó nuestra forma de operar.",
    author: "María González",
    role: "CEO",
    company: "Servicios Digitales",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400"
  },
  {
    id: 2,
    quote: "Pasé de operar todo a construir sistemas que operan por mí. El cambio fue radical.",
    author: "Pedro Ramírez",
    role: "Emprendedor",
    company: "EdTech Solutions",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400"
  },
  {
    id: 3,
    quote: "Esto no es un curso, es acceso a emprendedores y procesos reales. Valió cada segundo.",
    author: "Laura Sánchez",
    role: "Consultora Digital",
    company: "Growth Partners",
    image: "https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=400"
  },
  {
    id: 4,
    quote: "El enfoque práctico y la comunidad hicieron la diferencia. Aquí creces con otros, no contra otros.",
    author: "Javier Torres",
    role: "Emprendedor",
    company: "StartupHub",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400"
  },
  {
    id: 5,
    quote: "La mejor inversión que hice en mi carrera. Contenido actualizado, mentores accesibles, resultados reales.",
    author: "Carmen Vega",
    role: "Directora",
    company: "Innovation Labs",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400"
  },
  {
    id: 6,
    quote: "Urpe me enseñó a pensar en sistemas, no en tareas. Ahora mi negocio escala sin que yo esté en todo.",
    author: "Roberto Díaz",
    role: "Emprendedor",
    company: "SaaS Ventures",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400"
  }
];

export const curriculum = [
  {
    id: 1,
    title: "Estrategia e Innovación Tecnológica",
    description: "Pensamiento 10x, diseño de categorías, moats y growth loops.",
    icon: "Target",
    fullDescription: "Forma pensadores estratégicos capaces de crear ventajas competitivas en entornos digitales. El estudiante aprende a detectar oportunidades, diseñar categorías, construir ventajas competitivas y liderar con mentalidad exponencial.",
    competencies: "Pensamiento 10x, diseño de categorías, innovación aplicada, growth loops, pricing estratégico y ética tecnológica."
  },
  {
    id: 2,
    title: "Emprendimiento y Negocio Digital",
    description: "De idea a empresa: validación, modelos de ingreso y GTM.",
    icon: "Rocket",
    fullDescription: "Entrena fundadores y empresarios digitales que crean modelos de negocio rentables desde cero. El alumno pasa de la idea al producto validado, domina métricas como LTV, CAC, Payback y diseña estructuras de rentabilidad sostenibles.",
    competencies: "Validación de ideas, diseño de modelos de ingreso, escalamiento, capitalización y gestión legal global."
  },
  {
    id: 3,
    title: "Inteligencia Artificial Aplicada a los Negocios",
    description: "Prompting, RAG, agentes y adopción de IA en 90 días.",
    icon: "Brain",
    fullDescription: "Desarrolla profesionales capaces de integrar IA en todas las áreas operativas de una empresa: marketing, ventas, soporte, finanzas y operaciones. El estudiante deja de ser consumidor pasivo de tecnología para convertirse en arquitecto de soluciones inteligentes.",
    competencies: "Prompting, RAG, automatización con IA, análisis predictivo, implementación corporativa y gobierno ético de IA."
  },
  {
    id: 4,
    title: "Automatización, No-Code y Ciencia de Datos",
    description: "Sistemas sin código, APIs, dashboards y bots operativos.",
    icon: "Zap",
    fullDescription: "Enseña a construir sistemas, flujos y herramientas sin necesidad de programar. El alumno aprende a conectar datos, integrar APIs, crear dashboards y transformar operaciones humanas en procesos automatizados.",
    competencies: "Arquitectura no-code, automatización empresarial, analítica de datos, dashboards y gobernanza digital."
  },
  {
    id: 5,
    title: "Marketing de Performance y Adquisición de Clientes",
    description: "Meta, Google, YouTube, TikTok, atribución y escalamiento.",
    icon: "TrendingUp",
    fullDescription: "Forma estrategas de crecimiento capaces de escalar ventas con precisión matemática. Los estudiantes dominan media buying, IA en campañas, atribución multicanal y optimización de presupuesto en ecosistemas digitales.",
    competencies: "Performance marketing, IA media buying, tracking avanzado, analítica omnicanal y escalamiento publicitario."
  },
  {
    id: 6,
    title: "Ofertas Irresistibles, Embudos y Monetización Digital",
    description: "Ofertas irresistibles, CRO, monetización y referidos.",
    icon: "ShoppingCart",
    fullDescription: "Capacita para construir sistemas de venta automatizados y sostenibles. El alumno diseña ofertas irresistibles, embudos de conversión y estrategias de retención que convierten conocimiento en ingresos recurrentes.",
    competencies: "Copywriting persuasivo, embudos automatizados, CRO, programas de fidelización y monetización avanzada."
  },
  {
    id: 7,
    title: "Ventas, Influencia y Comunicación Estratégica",
    description: "Venta consultiva, cierre ético y negociación avanzada.",
    icon: "MessageSquare",
    fullDescription: "Entrena a profesionales y fundadores para liderar desde la persuasión ética y la comunicación de alto impacto. El estudiante domina técnicas de negociación, frameworks de cierre y liderazgo comunicacional.",
    competencies: "Neuroventas, persuasión ética, negociación avanzada, comunicación pública y liderazgo comercial."
  },
  {
    id: 8,
    title: "Marca Personal, Influencia Digital y Audiencia",
    description: "Autoridad digital, PR, contenido con IA y monetización.",
    icon: "Users",
    fullDescription: "Forma líderes de pensamiento capaces de construir autoridad en la era digital. El alumno aprende a posicionarse, crear contenido con IA, crecer orgánicamente y monetizar su influencia.",
    competencies: "Branding estratégico, storytelling, creación de contenido con IA, PR digital y reputación de marca."
  },
  {
    id: 9,
    title: "Liderazgo, Gestión y Operaciones Empresariales",
    description: "Organización, cultura, finanzas, operaciones y escalado.",
    icon: "Building2",
    fullDescription: "Prepara directivos para dirigir empresas tecnológicas con visión, estructura y cultura sólida. El estudiante domina operaciones, finanzas, gestión de equipos, escalabilidad global y toma de decisiones bajo incertidumbre.",
    competencies: "Liderazgo operativo, gestión de talento, cultura organizacional, dirección estratégica y productividad ejecutiva."
  },
  {
    id: 10,
    title: "Métricas, KPIs y Dirección Basada en Datos",
    description: "Dashboards ejecutivos, forecasting y cultura data-driven.",
    icon: "BarChart3",
    fullDescription: "Desarrolla líderes \"data-driven\" obsesionados con la evidencia. El alumno aprende a diseñar sistemas de indicadores, interpretar datos financieros, operativos y comerciales, y dirigir con precisión matemática.",
    competencies: "Analítica ejecutiva, dashboards integrados, forecasting, gobernanza de datos y cultura métrica institucional."
  }
];

export const faqData = [
  {
    id: 1,
    question: "¿Qué hace diferente a Urpe?",
    answer: "Enseñamos para ejecutar: metodología Learn → Apply → Measure → Scale. Cada módulo termina en un proyecto funcional con impacto medible."
  },
  {
    id: 2,
    question: "¿Quiénes enseñan?",
    answer: "Fundadores y operadores en activo que muestran sus procesos, métricas y decisiones reales."
  },
  {
    id: 3,
    question: "¿Cuánto dura el programa?",
    answer: "El programa tiene una duración de 17 semanas. Las sesiones son en vivo, 6 horas por semana, diseñadas para que puedas aplicar lo aprendido inmediatamente en tu negocio mientras mantienes tu ritmo profesional."
  },
  {
    id: 4,
    question: "¿Necesito conocimientos previos?",
    answer: "No. Requisitos: disciplina, responsabilidad y deseo real de independencia."
  },
  {
    id: 5,
    question: "¿Existen becas y pagos flexibles?",
    answer: "Sí. Beca Libertad del 50% al 100% según perfil. Inversión inicial de US$500 si eres aceptado."
  },
  {
    id: 6,
    question: "¿Puedo aplicar si ya tengo un negocio?",
    answer: "Sí. Nuestro programa está diseñado tanto para quienes están construyendo su primera empresa como para fundadores que quieren escalar o pivotar."
  },
  {
    id: 7,
    question: "¿Cómo es la comunidad?",
    answer: "Grupo privado en WhatsApp donde interactúas con fundadores, mentores y pares. Aquí no compites, evolucionas con otros de alto nivel."
  }
];

export const features = [
  {
    id: 1,
    title: "100% Online",
    description: "Aprende desde cualquier lugar"
  },
  {
    id: 2,
    title: "Acceso de por vida",
    description: "Contenido actualizado constantemente"
  },
  {
    id: 3,
    title: "Certificado",
    description: "Credencial verificable"
  }
];

export const whyUrpe = [
  {
    id: 1,
    title: "Fundadores Reales",
    description: "No aprendes de profesores, aprendes de fundadores en activo que abren sus procesos, números y decisiones reales.",
    image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800"
  },
  {
    id: 2,
    title: "Comunidad Exclusiva",
    description: "Acceso a grupo privado de WhatsApp para feedback en tiempo real. Aquí no compites, creces con otros.",
    image: "https://images.unsplash.com/photo-1573167507387-6b4b98cb7c13?w=800"
  },
  {
    id: 3,
    title: "Aplicación Inmediata",
    description: "Cada lección se traduce en acción. No teoría abstracta, sino herramientas que usas desde el día 1.",
    image: "https://images.unsplash.com/photo-1606857521015-7f9fcf423740?w=800"
  }
];
